import React, { FC } from 'react'
import cx from 'classnames'

import * as SC from './styled'

type SlotDay = {
  morning?: React.ReactNode
  afternoon?: React.ReactNode
}

export type PeriodTableProps = {
  className?: string
  labels: {
    columnLabel?: string
    morningRowLabel: string
    afternoonRowLabel: string
    mondayLabel: string
    tuesdayLabel: string
    wednesdayLabel: string
    thursdayLabel: string
    fridayLabel: string
    saturdayLabel: string
    sundayLabel: string
  }
  monday: SlotDay
  tuesday: SlotDay
  wednesday: SlotDay
  thursday: SlotDay
  friday: SlotDay
  saturday: SlotDay
  sunday: SlotDay
  withGrid?: boolean
}

const PeriodTable: FC<PeriodTableProps> = ({
  className,
  labels,
  monday,
  tuesday,
  wednesday,
  friday,
  saturday,
  sunday,
  thursday,
  withGrid,
}) => {
  return (
    <SC.Table className={cx('PeriodTable', className)} $withGrid={withGrid}>
      <SC.Thead>
        <SC.Tr>
          <SC.Th>{labels.columnLabel}</SC.Th>
          <SC.Th>{labels.mondayLabel}</SC.Th>
          <SC.Th>{labels.tuesdayLabel}</SC.Th>
          <SC.Th>{labels.wednesdayLabel}</SC.Th>
          <SC.Th>{labels.thursdayLabel}</SC.Th>
          <SC.Th>{labels.fridayLabel}</SC.Th>
          <SC.Th>{labels.saturdayLabel}</SC.Th>
          <SC.Th>{labels.sundayLabel}</SC.Th>
        </SC.Tr>
      </SC.Thead>
      <SC.Tbody>
        <SC.Tr>
          <SC.Th>{labels.morningRowLabel}</SC.Th>
          <SC.Td $cornerTopLeft>{monday.morning}</SC.Td>
          <SC.Td>{tuesday.morning}</SC.Td>
          <SC.Td>{wednesday.morning}</SC.Td>
          <SC.Td>{thursday.morning}</SC.Td>
          <SC.Td>{friday.morning}</SC.Td>
          <SC.Td>{saturday.morning}</SC.Td>
          <SC.Td $cornerTopRight>{sunday.morning}</SC.Td>
        </SC.Tr>
        <SC.Tr>
          <SC.Th>{labels.afternoonRowLabel}</SC.Th>
          <SC.Td $cornerBottomLeft>{monday.afternoon}</SC.Td>
          <SC.Td>{tuesday.afternoon}</SC.Td>
          <SC.Td>{wednesday.afternoon}</SC.Td>
          <SC.Td>{thursday.afternoon}</SC.Td>
          <SC.Td>{friday.afternoon}</SC.Td>
          <SC.Td>{saturday.afternoon}</SC.Td>
          <SC.Td $cornerBottomRight>{sunday.afternoon}</SC.Td>
        </SC.Tr>
      </SC.Tbody>
    </SC.Table>
  )
}

export default PeriodTable
